import './Header.scss';

const Header = () => {
  return (
    <header className="header">
      <div className="header__content">

        <div className="header__envelope-container">
          <img
            className="header__envelope header__envelope--desktop"
            src="/конверт 1.png"
            alt="Свадебное приглашение"
          />
          {/*<img */}
          {/*  className="header__envelope header__envelope--mobile"*/}
          {/*  src="/конверт 1-1.png" */}
          {/*  alt="Свадебное приглашение"*/}
          {/*/>*/}
        </div>
      </div>
    </header>
  );
};

export default Header;
